export class EstimatePrototyp{
  public id = null;
  public name = null;
  public dauer = null;
  public order_id = null;
  public price_unit = null;

  constructor(){}
}



// WEBPACK FOOTER //
// ./src/assets/shared/estimate.object.ts